import React, { useContext } from "react";
import Cards from "../components/Cards";
import Header from "../components/Header";
import CardHisto1 from "../components/historiaClinica/CardHisto1";
import CardHisto2 from "../components/historiaClinica/CardHisto2";
import CardHisto3 from "../components/historiaClinica/CardHisto3";
import { Image } from "react-bootstrap";
import Context from "../Context";

const HistoriaClinica = () => {
  const { showLogo } = useContext(Context);

  {
    /* Fecha */
  }

  const today = new Date();

  const date =
    today.getDate() +
    " / " +
    (today.getMonth() + 1) +
    " / " +
    today.getFullYear();

  {
    /* end fecha */
  }

  return (
    <>
      <section id="historiaClinica">
        
          {showLogo && (
            <Image
              className="logoPDF"
              src="./assets/images/cmf-logo.png"
              alt="logo cmf"
            />
          )}
          {/* <span className="date">{date}</span> */}
       

        <Header title="Historia Clínica" />

        <div className="wraper-cards">
          <CardHisto1 />
          <CardHisto2 />
          <CardHisto3 />
        </div>
      </section>
    </>
  );
};

export default HistoriaClinica;
